import React, { useEffect } from "react";

import { DotsLoader, Textfield } from "@similarweb/ui-components";

import { StyledDropdownSearch, StyledSeparator } from "./styles";

export type DropdownSearchProps = {
    value: string;
    open: boolean;
    placeholder: string;
    className?: string;
    onChange(v: string): void;
    isFocused?: boolean;
    isHiddenSeparator?: boolean;
    isLoading?: boolean;
};

const DropdownSearch: React.FC<DropdownSearchProps> = ({
    open,
    value,
    placeholder,
    onChange,
    className = null,
    isHiddenSeparator = false,
    isLoading = false,
    isFocused,
}) => {
    const inputRef = React.useRef(null);

    useEffect(() => {
        if (open) {
            inputRef?.current?.inputRef?.focus?.();

            if (inputRef?.current?.inputRef?.value) {
                inputRef?.current?.setValue?.("");
                onChange("");
            }
        }
    }, [open, inputRef]);

    useEffect(() => {
        if (isFocused) {
            inputRef?.current?.inputRef?.focus?.();
        }
    }, [isFocused, inputRef]);

    return (
        <StyledDropdownSearch
            className={className}
            isLoading={isLoading}
        >
            {!isHiddenSeparator ? <StyledSeparator /> : null}
            <Textfield
                hideBorder
                ref={inputRef}
                iconName="search"
                onChange={onChange}
                defaultValue={value}
                placeholder={placeholder}
                dataAutomation="dropdown-search-input"
            />
            {isLoading ? <DotsLoader /> : null}
        </StyledDropdownSearch>
    );
};

export default React.memo(DropdownSearch);
